import { Directive } from '@angular/core';
import { NG_VALIDATORS, FormControl, Validator, ValidationErrors } from '@angular/forms';

import { BookService } from './../../services/book.service';


@Directive({
  selector: '[related-product-validator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: RelatedProductValidatorDirective, multi: true }]
})
export class RelatedProductValidatorDirective implements Validator {

  constructor(private bookService: BookService) { }

  validate(c: FormControl): ValidationErrors {
    // console.log('related-product-validator', c.value);
    const isValid =
      c.value
      && c.value.tipologia
      && c.value.ean13
      && this.bookService.checkEan(c.value.ean13);
    const message = {
      'related-product': {
        'message': 'Specificare correttamente entrambi i campi'
      }
    }
    return isValid ? null : message;
  }
}



// WEBPACK FOOTER //
// ./src/app/helpers/validators/related-product-validator.directive.ts